<template>
  <div class="student-detail">
    <div class="section">
      <div class="profile-photo">
        <el-image
          style="width: 120px; height: 120px"
          src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
          fit="cover"
        ></el-image>
      </div>
      <div class="info">
        <h1>{{ info.name }}</h1>
        <div class="title">
          <p>学员编号：{{ info.student_code }}</p>
          <p>用户名：{{ info.curriculum_name }}</p>
          <p>出生日期：{{ info.birthday }}</p>
        </div>
        <div class="title">
          <p>性别：{{ info.sex }}</p>
          <p>录入时间：{{ info.created_time }}</p>
          <p>{{ info.parent_a }}电话：{{ info.parent_a_phone_num }}</p>
        </div>
        <div class="title">
          <p>在校年级：{{ info.gradeStr }}</p>
          <p>所在学校：{{ info.school_name }}</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentDetail } from "@/api/educational";
export default {
  name: "student-detail",
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getStudentDetail();
  },
  methods: {
    getStudentDetail() {
      getStudentDetail({
        student_id: this.$route.query.id,
      }).then((res) => {
        this.info = res.student_obj;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-detail {
  .section {
    display: flex;
    .profile-photo {
      width: 16%;
    }
    .info {
      width: 84%;
      h1 {
        font-size: 20px;
        font-weight: 500;
      }
      .title {
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        p {
          width: 28%;
        }
      }
    }
    box-sizing: border-box;
    margin: 20px;
    padding: 60px 40px 20px 40px;
    background-color: #fff;
    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #67c23a;
      margin-bottom: 10px;
    }
    ul {
    }
    li {
      list-style: square;
      line-height: 40px;
      font-size: 16px;
    }
    .btn {
      margin-top: 20px;
      font-size: 16px;
    }
  }
}
</style>
